import dynamic from 'next/dynamic';
import { Container } from './styles';
import { GraphicMap } from '../organisms/Graphic';
import { RankingContext } from '@/context/ranking';
import { Header } from '@/global/components/Header';
import { GraphMobile } from '../organisms/GraphicMobile';
import { SelectorArea } from '../organisms/SelectorArea';
import { Footer } from '@/components/ranking/atoms/Footer';
import { AreaVariation } from '../organisms/AreaVariation';
import AcceptCookies from '@/global/components/AcceptCookies';
import React, { useContext, useEffect, useMemo } from 'react';
import { AreaVariationBest } from '../organisms/AreaVariationBest';
import { IndicatorSynthesis } from '../organisms/IndicatorSynthesis';
import { SelectorAreaMobile } from '../organisms/SelectorAreaMobile';
import { Gradiente, Legend, NumberSmall } from '../organisms/MapGraph/style';

const Map = dynamic(() => import('../organisms/MapGraph') as any, { ssr: false });
const MapMobile = dynamic(() => import('../organisms/mapMobile/map') as any, { ssr: false });
const ModalMap = dynamic(() => import('../organisms/ModalMap') as any, { ssr: false });

export const Content: React.FC = () => {
  const { RakingData, researchArea, firstPosition, setResearchArea } = useContext(RankingContext);
  const AreaSerach = useMemo(() => RakingData[researchArea], [researchArea, RakingData]);

  useEffect(() => {
    setResearchArea('Geral');
  }, []);

  return (
    <>
      <Container>
        <Header />
        <section>
          <div className='contente'>
            <div className='boxFather'>
              <div className='overContainer'>
                <div className="boxText">
                  <h4>Ranking do Índice dos Desafios da Gestão Estadual</h4>
                </div>
                <Map />
              </div>
            </div>
            <div className='section'>
              <SelectorArea />
              <GraphicMap data={RakingData} />
            </div>
          </div>
        </section>
        <div className='MapArticle'>
          <MapMobile />
          <div className='boxLegend'>
            <Legend>
              <small>Índice</small>
              <Gradiente small color={AreaSerach?.config?.color} />
              <div className="indices">
                <NumberSmall>{Number(firstPosition?.indice).toFixed(1)}</NumberSmall>
                <NumberSmall>0</NumberSmall>
              </div>
            </Legend>
          </div>


        </div>
        <SelectorAreaMobile />
        <GraphMobile />
        <AreaVariation />
        {researchArea !== 'Geral' && (
          <>
            <IndicatorSynthesis />
            <AreaVariationBest />
          </>
        )}
        <Footer modifyItem area='footer' />
        <ModalMap />
        <AcceptCookies />
      </Container>
    </>
  );
};
